export default __webpack_public_path__ + "static/media/4th-and-lawn.1d63f121.png";